import { TContentType } from '@/types/Content.types';
import { HStack, Text } from '@chakra-ui/react';
import { getContentTypeLabel } from './contentLabels';

// Content type label for thumbnail overlays.
const ContentTypeTag = ({ type }: { type: TContentType }) => {
  return (
    <HStack display="inline-flex" gap="6px" align="center">
      <Text fontSize="10px" fontWeight={900} color="white" opacity={0.8} textTransform="uppercase">
        {getContentTypeLabel(type)}
      </Text>
    </HStack>
  );
};

export default ContentTypeTag;
